module.exports = __webpack_public_path__ + "static/img/wechatCode.9d8a43f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wechatCode.jpg
// module id = b3fX
// module chunks = 1 2